// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"08054e2e","449":"e4dcad87","660":"514e3d1d","787":"6546bf8f"}[chunkId] + ".chunk.js";
};